import * as React from 'react';
import {authorize, Overlay} from "@athena-portal/components";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {FalconNavigatorHeader, resourcesHelper, Footer} from "@ferry/portal-core";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {Navigate} from "react-router";
import {getModifiedMobileNumber} from "../../../../CommonFunctions";
import {Types} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";

interface IState {
    interaction?: any;
    interactionFound?: boolean;
    loading?: boolean;
}

@authorize
export class MigratedRenewalAnnualAccountDetailsPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: {}) {
        super(props);

        this.state = {
            loading: false
        }
    }

    public componentDidMount() {
        {
            window.scrollTo(0, 0)
        }
        this.setState({loading: true});

        this.customerPortalService.getInteractionByStatus(['MIGRATED_RENEWAL', 'MIGRATED_RENEWAL_ACCEPTED'])
            .subscribe((interaction: any) => {
                if (interaction) {
                    this.setState({interaction, loading: false, interactionFound: true});
                } else {
                    this.setState({loading: false, interactionFound: false});
                }
            })

        this.pluginTemplates.setPageTitle("Your account details");
    }

    public render(): React.ReactNode {
        if (this.state.loading) {
            return <Overlay show={true}/>;
        } else if (this.state.interactionFound) {
            return (
                <>
                    <FalconHeader/>
                    <div className="plugin account-details-container">
                        <FalconNavigatorHeader
                            back="/dashboard/migratedRenewal"
                            title="Account details"
                        />
                        <div
                            className="plugin plugin-panel inner-container inner-content text-center account-details-section">
                            <div className="panel-detail-output-entity account-details-title p-0 icon-container">
                                <div>
                                    <img className="account-details-icon person-icon" alt="make-changes"
                                         src={`/${resourcesHelper.THEME_PATH}/img/account-details.svg`}/>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <div className="panel-detail-output-entity personal-details-name">
                                        <p className="h2 font-weight-bold">{this.state.interaction.policyHolder.firstName} {this.state.interaction.policyHolder.lastName}</p>
                                    </div>
                                    <div className="panel-detail-output-entity">
                                        <label className="account-details date-of-birth">Date of birth:</label>
                                        {PluginTemplates.convertDate(this.state.interaction.policyHolder.dateOfBirth, "D MMMM YYYY")}
                                    </div>
                                </div>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon"
                                         aria-label="Divider line"/>
                                </div>
                                <div>
                                    <div className="panel-detail-output-entity">
                                        <label className="account-details phone font-weight-bold">Phone number:</label>
                                        {getModifiedMobileNumber(this.state.interaction.policyHolder.phoneNumber)}
                                    </div>
                                    <div className="panel-detail-output-entity">
                                        <label className="account-details email font-weight-bold">Email:</label>
                                        {this.state.interaction.policyHolder.email}
                                    </div>
                                </div>

                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon"
                                         aria-label="Divider line"/>
                                </div>
                                <div>
                                    <div className="panel-detail-output-entity account-details-title p-0">
                                        <h2 className="inner-content dashboard-panel-title">Address</h2>
                                    </div>
                                    <div className="panel-detail-output-entity address-details">
                                        <p id="full-address">{this.state.interaction.policyHolder.address.fullAddress}</p>
                                    </div>
                                </div>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon"
                                         aria-label="Divider line"/>
                                </div>
                            </div>
                        </div>
                        {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/migratedRenewal`)}
                    </div>
                    <Footer/>
                </>
            )
        } else if (this.state.interactionFound === false) {
            return  <Navigate to={`/dashboard`}/>
        }
        return <></>
    }
}
